import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { fetchMaxUsers, fetchUsers, fetchApiCalls } from 'api/metrics'
import { useRootLoaderData } from 'components/Root.loader'
import { useState, useEffect, useCallback } from 'react'

import APICallCountPanel from './APICallCountPanel'
import HelpIcon from './HelpIcon'
import UserCountPanel from './UserCountPanel'

export default function UsageThisMonth() {
  const rootData = useRootLoaderData()
  const [usersCount, setUsersCount] = useState<Parameters<typeof UserCountPanel>[0]>()
  const [apisCount, setApisCount] = useState<Parameters<typeof APICallCountPanel>[0]>()
  const userGroupConfig = rootData.userGroupConfig

  const reload = useCallback(async () => {
    const today = new Date()
    const [y, m, d] = [today.getFullYear(), today.getMonth() + 1, today.getDate()]
    const lastDate = new Date(y, m, 0).getDate() // m: from 0

    try {
      const data = {
        maxCount: (await fetchMaxUsers(m)).count,
        count: (await fetchUsers()).count,
      }
      setUsersCount(data)
      // TODO lastDate 0 prefix
      const apiData = {
        month: await fetchApiCalls('month', {
          fromDate: `${y}-${m}-01`,
          toDate: `${y}-${m}-${lastDate}`,
        }),
        day: await fetchApiCalls('day', { fromDate: `${y}-${m}-${d}`, toDate: `${y}-${m}-${d}` }),
      }

      const apisCount: Record<string, any> = {
        invoice: { count: 0, todayCount: 0 },
        orderForm: { count: 0, todayCount: 0 },
        template: { count: 0, todayCount: 0 },
        general: { count: 0, todayCount: 0 },
      }
      apiData.month.forEach((i) => {
        if (!['invoice', 'order_form', 'template', 'general'].includes(i.apiType)) {
          // why here?
          throw new Error(`unknown api type ${i.apiType}`)
        }
        const k = i.apiType === 'order_form' ? 'orderForm' : i.apiType
        apisCount[k].count = i.apiCallCount
      })
      apiData.day.forEach((i) => {
        const k = i.apiType === 'order_form' ? 'orderForm' : i.apiType
        apisCount[k].todayCount = i.apiCallCount
      })
      if (!userGroupConfig.useInvoiceOCR) apisCount.invoice = undefined
      if (!userGroupConfig.useOrderForm) apisCount.orderForm = undefined
      if (!userGroupConfig.useOCRBuilder) apisCount.template = undefined
      if (userGroupConfig.useConcur) apisCount.general = undefined
      setApisCount(apisCount)
    } catch (e) {
      // TODO: should we alert this error msg?
    }
  }, [userGroupConfig])

  useEffect(() => {
    reload()
  }, [reload])

  return (
    <Box>
      <p>
        <Typography gutterBottom component="span">
          今月の利用状況
        </Typography>
        <Typography variant="body2" component="span" sx={{ ml: 2.5, fontSize: 12 }}>
          ※ダッシュボード上のコール数とご請求のコール数が異なる場合がございます。詳しくは
          <HelpIcon text="こちら" />
          をご参照ください。
        </Typography>
      </p>
      <Box sx={{ display: 'flex', gap: 2.5 }}>
        <UserCountPanel {...usersCount} totalCount={userGroupConfig.maximumCount} />
        <APICallCountPanel {...apisCount} />
      </Box>
    </Box>
  )
}
